
import ImgToPdf from "../components/ImgToPdf";
import Unipage from "../templates/Unipage";


export default function Home(props) {
	
	document.title = props.pageTitle;
	return (
		<Unipage
			content={
				<>
					
					<h1>{props.title} </h1>
					<div className="row m-0 p-0">
						<div className="col-12 p-0 mx-auto">
							<ImgToPdf
								accept={
									{ "image/*": [] }
								}
								height="7.5em" color="black" bgColor="whitesmoke" />

                            <h2>
                                FAQ: Img2pdf Converter
                            </h2>
                            <div id="faq">
                                <h3>What file formats can I convert to PDF?</h3>
                                <p>You can convert all common image types: JPG/JPEG, PNG, GIF, WEBP, BMP, and TIFF.</p>

                                {/*<h3>Why should I convert images to a PDF?</h3>
					    <p>
						    Sending multiple images individually can be inconvenient.
						    A PDF lets you place many images into a single file, which is easier to share and keep organized.
						    This is useful for things like photo collections, design drafts, or any situation where you want everything in one place.
					    </p>*/}

                                <h3>How do I convert my images?</h3>

                                <p>
                                    Upload your images by dragging them into the tool or selecting them from your device.
                                </p>
                                <p>
                                    The download PDF arrow below the image thumbnail will convert the image to PDF and download the resulting PDF file.
                                    The red "Download Combined PDF" button will convert all images in the queue to PDF and download the result as one PDF file.
                                    The yellow "Download All as ZIP" button will convert all images in the queue to PDF and downloads all result PDFs together in a single zip archive.

                                </p>
                                <p>
                                    Img2pdf works in any browser on Windows, Mac, or mobile devices.
                                    There is no software to install, and there is no limit to the number of images you can convert.
                                </p>

                                <h3>Will converting my images reduce their quality?</h3>
                                <p>
                                    No.
                                    Img2pdf embeds the original image data directly into the PDF, so your images will retain their original quality.
                                </p>
                                <p>
                                    This is true even if you use the manual overrides to reduce the size of the output PDF. The original data is embedded in the PDF, just rendered smaller. You will still be able to see the image in its full quality by zooming in.
                                </p>

                                <h3>Will converting my images take a long time?</h3>
                                <p>
                                    No. It will take approximately 25-50 ms to process each image. That's roughly 30 images per second or 1,800 images per minute.
                                </p>
                                <p>
                                    There is no time cost of uploading or downloading images because everything is processed by the browser on your device.
                                </p>

                                <h3>Is the conversion process secure?</h3>
                                <p>
                                    Yes.
                                    Your files stay on your computer and are never uploaded to a server.
                                </p>

                                <h3>Is Img2pdf free to use?</h3>
                                <p>
                                    Yes.
                                    It is completely free.
                                </p>
                            </div>
                            <hr style={{ color: "lightgray" }} />

						</div>
					</div>
				</>
			}
		/>
	);
}